import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { BooleanValueAccessor, CoreToggleButton } from "@svs/angular";

@Component({
  selector: "app-settings-contrast-mode-toggle",
  imports: [
    CoreToggleButton,
    ReactiveFormsModule,
    BooleanValueAccessor,
  ],
  templateUrl: "./settings-contrast-mode-toggle.component.html",
  styleUrl: "./settings-contrast-mode-toggle.component.css",
})
export class SettingsContrastModeToggleComponent {
  @Input() form!: FormGroup;

  get contrastModeFormControl(): FormControl {
    return this.form.get("contrastMode") as FormControl;
  }

}
